import { createAction, props, union } from '@ngrx/store';
import { CompanySubset } from 'app/api/company.api.service';

const source = 'companies';
const actions = 'api';

export const companiesRequested = createAction(`[${source}][${actions}] Companies requested`);
export const companiesLoaded = createAction(`[${source}][${actions}] Companies loaded`, props<{ companies: CompanySubset[] }>());
export const companiesCancelled = createAction(`[${source}][${actions}] Companies cancelled`, props<{ errorMessage: string }>());

const all = union({
  companiesRequested,
  companiesLoaded,
  companiesCancelled,
});

export type CompaniesActionsUnion = typeof all;
